<section class="mt-3">
  <div class="container">
      <div class="row">
          <div class="col-md-12 mb-3">
              <div class="float-right">
                <button class="btn dash-btns mr-3" [routerLink]="['/PayOut/ManagePayOutContact']">Manage PayOut
                  Contact</button>
    
                <button [routerLink]="['/reports/transactions/summary']" class="btn dash-btns">Reports</button>
    
              </div>
          </div>
          <div class="col-md-6">
              <div class="card-1">
                  
                  <h4 class="gary-t pt-35 font-20 mb-0">Edit PayOut Contact</h4>
                  <div class="pt-35">
                    <form>
                      <div class=" p-2">
                        <div class="row pt-2">
    
                          <div class="col-lg-6 col-md-6">
                            <label class="gary-t  l-h21 font-14 mb-3">Payout Customer keyId*</label>
                          </div>
    
                          <div class="col-lg-6  col-md-6">
                            <!-- <div class="form-group formgroup-tm"> -->
                            <!-- <input class="formcontrol-user1 form-control" type="text" placeholder="Payout Customer keyId" [(ngModel)]="rows.PayoutCustomerkeyId" id="PayoutCustomerId" name="PayoutCustomerId"  [formControl]="PayoutCustomerId" readonly> -->
                            <label>{{rows.PayoutCustomerkeyId}}</label>
    
                            <!-- </div> -->
                            <span class="text-danger"
                              *ngIf="PayoutCustomerId.invalid && (PayoutCustomerId.dirty || PayoutCustomerId.touched)">{{PayoutCustomerkeyIderrors()}}</span>
                          </div>
                        </div>
                        <div class="row pt-2"> 
    
                          <div class="col-lg-12">
                           
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">Customer Id*</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="Customer Id" id="CId" name="CId" [(ngModel)]="rows.CustomerId"
                                [formControl]="CId" (keydown)="onKey()" (change)=onChange()>
                            </div>
                           
                          </div>
                        </div>
    


                        <div class="row pt-2" *ngIf="AccountIdmandatory">
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm " *ngIf="redabelAccountId">
                              <label class="customlabel">Customer AccountId*</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="Customer AccountId" id="CustomerAccountId"
                                name="CustomerAccountId" [formControl]="CustomerAccountId"  maxlength="5" required (change)=CheckCustomerAccountId() (keydown)="onKey()" [(ngModel)]="rows.CustomerAccountId" readonly>
          
                                
          
                            </div>

                            <div class="form-group formgroup-tm " *ngIf="EditAccountId">
                              <label class="customlabel">Customer AccountId*</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="Customer AccountId" id="CustomerAccountId"
                                name="CustomerAccountId" [formControl]="CustomerAccountId"  maxlength="5" required (change)=CheckCustomerAccountId() (keydown)="onKey()" [(ngModel)]="rows.CustomerAccountId" >
          
                                
          
                            </div>
                           
                          </div>
                        </div>


                        <div class="row pt-2" *ngIf="AccountIdnonmandatory">
                          <div class="col-lg-12">
                           
                            <div class="form-group formgroup-tm" *ngIf="redabelAccountId">
                              <label class="customlabel">Customer AccountId</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="Customer AccountId" id="CustomerAccountId"
                                name="CustomerAccountId" [formControl]="CustomerAccountId"  maxlength="5" required (change)=CheckCustomerAccountId() (keydown)="onKey()" [(ngModel)]="rows.CustomerAccountId" readonly>
          
                                
          
                            </div>
                            <div class="form-group formgroup-tm" *ngIf="EditAccountId">
                              <label class="customlabel">Customer AccountId</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="Customer AccountId" id="CustomerAccountId"
                                name="CustomerAccountId" [formControl]="CustomerAccountId"  maxlength="5" required (change)=CheckCustomerAccountId() (keydown)="onKey()" [(ngModel)]="rows.CustomerAccountId">
                            </div>
                              </div>
                        </div>

          
                        <div class="row pt-2"> 
    
                          <div class="col-lg-12">
                           
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">Company Name </label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="Company Name" id="CompanyName" name="CompanyName"
                                [(ngModel)]="rows.CompanyName" [formControl]="CName" (keydown)="onKey()">
                            </div>
                            <!-- <span class="text-danger" *ngIf="CName.invalid && (CName.dirty || CName.touched)">{{CompanyNameerrors()}}</span> -->
                          </div>
                        </div>
    
                        <!-- <div class="row pt-2">
    
                                        <div class="col-lg-4 col-md-5">
                                            <label class="customlabel">Company Name<span
                                                    class="text-danger">*</span></label>
                                        </div>
                                          
                                          <div class="col-lg-6  col-md-6">
                                            <div class="form-group formgroup-tm">
                                            <input class="formcontrol-user1 form-control" type="text" placeholder="Company Name" id="CompanyName" name="CompanyName"  [formControl]="CompanyName">
                                            </div>
                                          
                                        </div>
                                    </div> -->
    
    
                        <div class="row pt-2"> 
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">First Name*</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="First Name" id="FName" name="FName"
                                [(ngModel)]="rows.FirstName" [formControl]="FName" (keydown)="onKey()">
                            </div>
                           
                          </div>
                        </div>
                        <div class="row pt-2"> 
                          <div class="col-lg-12">
                           
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">Last Name </label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="Last Name" id="LName" name="LName" [(ngModel)]="rows.LastName"
                                [formControl]="LName" (keydown)="onKey()">
                            </div>
                            
                          </div>
                        </div>
 
                       
                        <!-- <div class="row pt-2">
    
                                  <div class="col-lg-4 col-md-5">
                                      <label class="customlabel">Last Name<span
                                              class="text-danger">*</span></label>
                                  </div>
                                    
                                    <div class="col-lg-6  col-md-6">
                                      <div class="form-group formgroup-tm">
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Last Name" id="LastName" name="LastName" >
                                      </div>
                                    
                                  </div>
                              </div> -->
                        <div class="row pt-2"> 
                          <div class="col-lg-12">
                           
                            <div class="form-group formgroup-tm">
                              <label class="customlabel"> Address*</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="Address" id="Addres" name="Address"
                                [(ngModel)]="rows.Address" [formControl]="CAddress" (keydown)="onKey()"  >
    
    
                            </div>
                           
                              
                          </div>
                        </div>
                        <div class="row pt-2"> 
    
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">ZipCode </label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="ZipCode" id="CZipCode" name="CZipCode"
                                [(ngModel)]="rows.ZipCode" [formControl]="CZipCode" maxlength="6" (keydown)="onKey()" (change)="Getzipcodedetails()">
                            </div>
                       
                          </div>
                        </div>
    
                        <div class="row pt-2"> 
    
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">City*</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="City" id="City" name="City" [(ngModel)]="cCity"
                                [formControl]="CCity" (keydown)="onKey()">
                            </div>
                            
                          </div>
                        </div>
                        <div class="row pt-2"> 
    
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">State*</label>
                              <div class="selectcustom mb-0">
                                <ngx-select [items]="stateList" placeholder="State" id="CState" name="CState"
                                [formControl]="CState" [(ngModel)]="state" (keydown)="onKey()">
                              </ngx-select>
                              </div>
                            
                              <!-- <input class="formcontrol-user1 form-control" type="text" placeholder="State" id="CState" name="CState"  [(ngModel)]="rows.State" [formControl]="CState"> -->
                            </div>
                            
                          </div>
                        </div>
                        <div class="row pt-2"> 
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">Country </label>
                              <!-- <input class="formcontrol-user1 form-control" type="text" placeholder="Country" id="cCountry" name="cCountry"   [(ngModel)]="rows.Country" [formControl]="cCountry" (keydown)="onKey()"> -->
                              <div class="selectcustom mb-0">
                                <ngx-select [items]="CountryList" placeholder="Country" id="cCountry" name="cCountry"
                                [(ngModel)]="PCountry" [formControl]="cCountry" (keydown)="onKey()">
                              </ngx-select>
                              </div>
                        
                            </div>
                           
                          </div>
                        </div>
                        <div class="row pt-2"> 
                          <div class="col-lg-12">
                           
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">MobileNo*</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="MobileNo" id="cMobileNo" name="cMobileNo"
                                [(ngModel)]="rows.MobileNo" [formControl]="cMobileNo" maxlength="10" (keydown)="onKey()">
                            </div>
                         
                          </div>
                        </div>
                        <div class="row pt-2"> 
    
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">MobileNo2 </label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="MobileNo2" id="cMobileNo2" name="cMobileNo2"
                                [(ngModel)]="rows.MobileNo2" [formControl]="cMobileNo2" maxlength="10" (keydown)="onKey()">
                            </div>
                          
                          </div>
                        </div>
                        <div class="row pt-2"> 
    
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">Email </label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="Email" id="cEmail" name="cEmail" [(ngModel)]="rows.Email"
                                [formControl]="cEmail" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$"
                                (keydown)="onKey()">
                            </div>
          
                          </div>
                        </div>
                        <div class="row pt-2"> 
                          <div class="col-lg-12">
                           
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">Email2 </label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="Email2" id="cEmail2" name="cEmail2" [(ngModel)]="rows.Email2"
                                [formControl]="cEmail2" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$"
                                (keydown)="onKey()">
                            </div>
                           
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="border-bottom mt-3">
                              <a class="accordion" (click)="toggleAccordian($event)">UserDefined </a>
                              <div class="panel text-left mt-3" hide="!item.isActive">
                                <div class="row pt-2">
     
    
                                  <div class="col-lg-12">
                                    
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">UserDefined1 </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="UserDefined1" id="UserDefined1" name="UserDefined1"
                                        [(ngModel)]="rows.UserDefined1" [formControl]="cUserDefined1" (keydown)="onKey()">
                                    </div>
    
                                  </div>
                                </div>
                                <div class="row pt-2"> 
                                  <div class="col-lg-12">
                                    
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">UserDefined2 </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="UserDefined2" id="UserDefined2" name="UserDefined2"
                                        [(ngModel)]="rows.UserDefined2" [formControl]="cUserDefined2" (keydown)="onKey()">
                                    </div>
    
                                  </div>
                                </div>
                                <div class="row pt-2"> 
                                  <div class="col-lg-12">
                                   
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">UserDefined3 </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="UserDefined3" id="UserDefined3" name="UserDefined3"
                                        [(ngModel)]="rows.UserDefined3" [formControl]="cUserDefined3" (keydown)="onKey()">
                                    </div>
    
                                  </div>
                                </div>
                                <div class="row pt-2"> 
                                  <div class="col-lg-12">
                                    
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">UserDefined4 </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="UserDefined4" id="UserDefined4" name="UserDefined4"
                                        [(ngModel)]="rows.UserDefined4" [formControl]="cUserDefined4" (keydown)="onKey()">
                                    </div>
    
                                  </div>
                                </div>
                                <div class="row pt-2"> 
    
                                  <div class="col-lg-12">
                                    

                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">UserDefined5 </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="UserDefined5" id="UserDefined5" name="UserDefined5"
                                        [(ngModel)]="rows.UserDefined5" [formControl]="cUserDefined5" (keydown)="onKey()">
                                    </div>
    
                                  </div>
                                </div>
                                <div class="row pt-2"> 
                                  <div class="col-lg-12">
                                   
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">UserDefined6 </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="UserDefined6" id="UserDefined6" name="UserDefined6"
                                        [(ngModel)]="rows.UserDefined6" [formControl]="cUserDefined6" (keydown)="onKey()">
                                    </div>
    
                                  </div>
                                </div>
                                <div class="row pt-2"> 
                                  <div class="col-lg-12">
                                    
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">UserDefined7 </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="UserDefined7" id="UserDefined7" name="UserDefined7"
                                        [(ngModel)]="rows.UserDefined7" [formControl]="cUserDefined7" (keydown)="onKey()">
                                    </div>
    
                                  </div>
                                </div>
                                <div class="row pt-2">     
                                  <div class="col-lg-12">
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">UserDefined8 </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="UserDefined8" id="UserDefined8" name="UserDefined8"
                                        [(ngModel)]="rows.UserDefined8" [formControl]="cUserDefined8" (keydown)="onKey()">
                                    </div>
    
                                  </div>
                                </div>
                                <div class="row pt-2"> 
                                  <div class="col-lg-12">
                                   
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">UserDefined9 </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="UserDefined9" id="UserDefined9" name="UserDefined9"
                                        [(ngModel)]="rows.UserDefined9" [formControl]="cUserDefined9" (keydown)="onKey()">
                                    </div>
    
                                  </div>
                                </div>
                                <div class="row pt-2"> 
                                  <div class="col-lg-12">
                                   
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">UserDefined10 </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="UserDefined10" id="UserDefined10" name="UserDefined10"
                                        [(ngModel)]="rows.UserDefined10" [formControl]="cUserDefined10" (keydown)="onKey()">
                                    </div>
    
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
    
                        <div class="text-left pt-3" *ngIf="AccountIdnonmandatory">
    
                          <button class="btn dash-btns"
                            [disabled]="FName.invalid|| CAddress.invalid || CCity.invalid || CState.invalid || CZipCode.invalid || cCountry.invalid || cMobileNo.invalid || cEmail.invalid ||cMobileNo2.invalid ||cEmail2.invalid ||!isReadytoUpdateInfo"
                            id="Savecoupon" color="primary"   (click)="EditPayOut()">Update
                            Now</button>
                        </div>
                        <div class="text-left pt-3" *ngIf="AccountIdmandatory">
    
                          <button class="btn dash-btns"
                            [disabled]="FName.invalid|| CAddress.invalid || CCity.invalid || CState.invalid || CZipCode.invalid || cCountry.invalid || cMobileNo.invalid || cEmail.invalid ||cMobileNo2.invalid ||cEmail2.invalid ||!isReadytoUpdateInfo||CustomerIdkeyid||CustomerAccountId.invalid"
                            id="Savecoupon" color="primary"   (click)="EditPayOut()">Update
                            Now</button>
                        </div>
                        <!-- CName.invalid || -->
                      </div>
                    </form>
                  </div>
              </div>
          </div>
          <div class="col-md-6">
            <div class="card-1 p-2">
                <div class="text-center">
                    <!-- <img src="assets/img/new/invoices.gif" /> -->
                    <div *ngIf="!isimgHidden">
                        <img src="https://fastswiff.com/assets/img/invoicce-management.png" class="w-100" alt="">
                    </div>
                    <div class="div">
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"  *ngIf="CustomerIdkeyid">Customer KeyId already exists</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                        *ngIf="CId.invalid && (CId.dirty || CId.touched)">{{CustomerIderrors()}}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"  *ngIf="CustomerAccountkeyid">Customer AccountId already exists</div>
    
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                        *ngIf="CustomerAccountId.invalid && (CustomerAccountId.dirty || CustomerAccountId.touched)">{{CustomerAccountIderrors()}}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                        *ngIf="FName.invalid && (FName.dirty || FName.touched)">{{FirstNameNameerrors()}}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                        *ngIf="LName.invalid && (LName.dirty || LName.touched)">{{LastNameerrors()}}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                        *ngIf="CAddress.invalid && (CAddress.dirty || CAddress.touched)">{{Addresserrors()}}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                        *ngIf="CCity.invalid && (CCity.dirty || CCity.touched)">{{Cityerrors()}}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                        *ngIf="CState.invalid && (CState.dirty || CState.touched)">{{Stateerrors()}}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"  *ngIf="CZipCode.invalid && (CZipCode.dirty || CZipCode.touched)">{{
                        ZipCodeerrors()
                        }}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                        *ngIf="cCountry.invalid && (cCountry.dirty || cCountry.touched)">{{Countryeerrors()}}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                        *ngIf="cMobileNo.invalid && (cMobileNo.dirty || cMobileNo.touched)">{{MobileNoeerrors()}}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                        *ngIf="cMobileNo2.invalid && (cMobileNo2.dirty || cMobileNo2.touched)">{{Mobil2eNoeerrors()}}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"  *ngIf="cEmail.invalid && (cEmail.dirty || cEmail.touched)">{{Emaileerrors()}}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                        *ngIf="cEmail2.invalid && (cEmail2.dirty || cEmail2.touched)">{{Email2eerrors()}}</div>
                    </div>
                </div>
            </div>
          </div>
      </div>
  </div>
</section>
















 